export default __webpack_public_path__ + "static/media/GAMA-500-TORNADO.2e79f7cb.pdf";